var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6",
    "data-name": "Group 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.331,
    height: 36.847,
    viewBox: "0 0 72.331 36.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 72.331,
    height: 36.847,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M55.328,82.55a5.365,5.365,0,1,0,5.366,5.365,5.371,5.371,0,0,0-5.366-5.365",
    transform: "translate(-34.156 -56.433)",
    fill: "#fcb615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M7.932,82.55A5.365,5.365,0,1,0,13.3,87.915,5.371,5.371,0,0,0,7.932,82.55",
    transform: "translate(-1.754 -56.433)",
    fill: "#ee363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M102.723,82.55a5.365,5.365,0,1,0,5.365,5.365,5.372,5.372,0,0,0-5.365-5.365",
    transform: "translate(-66.555 -56.433)",
    fill: "#05b057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M197.518,82.55a5.365,5.365,0,1,0,5.365,5.365,5.374,5.374,0,0,0-5.365-5.365",
    transform: "translate(-131.359 -56.433)",
    fill: "#03a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M150.122,82.55a5.365,5.365,0,1,0,5.365,5.365,5.371,5.371,0,0,0-5.365-5.365",
    transform: "translate(-98.959 -56.433)",
    fill: "#a1479a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M10.65,21.292a4.3,4.3,0,0,0-4.4-4.4,4.4,4.4,0,1,0,0,8.8,4.3,4.3,0,0,0,4.4-4.4M0,21.292a6.109,6.109,0,0,1,6.248-6.108A6.074,6.074,0,0,1,12.5,21.268v5.348a.89.89,0,0,1-.948.924.876.876,0,0,1-.945-.924V25.053h-.095A4.887,4.887,0,0,1,6.129,27.4,6.051,6.051,0,0,1,0,21.292",
    transform: "translate(0 -10.38)",
    fill: "#5a5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M57.932,21.294a4.4,4.4,0,1,0-4.4,4.4,4.3,4.3,0,0,0,4.4-4.4M49.7,31.353a.888.888,0,0,1-.545-1.16.8.8,0,0,1,1.161-.5,7.221,7.221,0,0,0,3.052.686,4.163,4.163,0,0,0,4.521-4.543v-.782h-.095A4.891,4.891,0,0,1,53.412,27.4a6.11,6.11,0,1,1,6.366-6.129v4.448c0,3.834-2.46,6.416-6.483,6.416a8.275,8.275,0,0,1-3.6-.781",
    transform: "translate(-32.324 -10.382)",
    fill: "#5a5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M105.21,21.292a4.4,4.4,0,1,0-4.4,4.4,4.305,4.305,0,0,0,4.4-4.4m-10.651,0a6.25,6.25,0,1,1,6.249,6.106,6.1,6.1,0,0,1-6.249-6.106",
    transform: "translate(-64.643 -10.38)",
    fill: "#5a5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M152.489,10.912a4.4,4.4,0,0,0-8.8,0,4.4,4.4,0,0,0,8.8,0m-10.651,0A6.053,6.053,0,0,1,147.969,4.8a4.89,4.89,0,0,1,4.377,2.345h.1V.925A.889.889,0,0,1,153.389,0a.875.875,0,0,1,.944.925v10.01a6.25,6.25,0,0,1-12.5-.023",
    transform: "translate(-96.964)",
    fill: "#5a5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M199.77,21.292a4.4,4.4,0,1,0-4.4,4.4,4.3,4.3,0,0,0,4.4-4.4m-10.65,0a6.251,6.251,0,0,1,12.5-.023v5.348a.89.89,0,0,1-.948.924.878.878,0,0,1-.948-.924V25.053h-.095A4.885,4.885,0,0,1,195.25,27.4a6.052,6.052,0,0,1-6.13-6.106",
    transform: "translate(-129.287 -10.38)",
    fill: "#5a5b5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgoda);
export default __webpack_public_path__ + "static/media/agoda.938b151ca64867cf4a267933e805ba46.svg";
export { ForwardRef as ReactComponent };